import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const TeamCollaborationHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2} sx={{ height: '100%' }}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Team Collaboration
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Enhance your team's hiring process with collaborative tools and features.
          Learn how to work together effectively to find and hire the best candidates.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Team Communication
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Use our built-in communication tools to discuss candidates, share feedback,
          and coordinate hiring decisions with your team members.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Shared Candidate Notes
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Collaborate on candidate evaluation by sharing notes, ratings, and feedback.
          Maintain a complete history of team interactions with each candidate.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Interview Coordination
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Coordinate interview schedules and feedback collection among team members.
          Ensure all stakeholders have the information they need to make hiring decisions.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Hiring Workflows
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Set up collaborative hiring workflows that involve multiple team members.
          Define approval processes and ensure everyone follows the same hiring procedures.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/team/collaboration"
            color="primary"
            variant="contained"
          >
            Configure Team Settings
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default TeamCollaborationHelp; 